"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtomicPredicateString = void 0;
const AbstractStringElement_1 = require("./AbstractStringElement");
const Predicate_1 = require("../../Predicate");
const NotString_1 = require("./NotString");
class AtomicPredicateString extends AbstractStringElement_1.AbstractStringElement {
    static getMatcher(config) {
        if (config.onlyValues) {
            return /^[^ )(]+/;
        }
        return /^\S+ +(IS|IS_NOT|LESS_THAN|LESS_THAN_OR_EQUAL|GREATER_THAN|GREATER_THAN_OR_EQUAL|STARTS_WITH|ENDS_WITH|CONTAINS).+?(?= +AND| +OR| +\)|$)/;
    }
    getPredicate(config) {
        let filterCriteria;
        let predicateDefinition;
        let parameterValue;
        const isNegated = this.getPrevious() instanceof NotString_1.NotString;
        if (config.onlyValues) {
            filterCriteria = config.defaultFilterCriteria;
            predicateDefinition = config.defaultPredicateDefinition;
            parameterValue = this.parsedString;
        }
        else {
            [filterCriteria, predicateDefinition, parameterValue] = this.parsedString.split(' ');
        }
        return new Predicate_1.Predicate({
            type: 'ATOMIC',
            isNegated,
            filterCriteria: filterCriteria,
            predicateDefinition: predicateDefinition,
            parameterValue: JSON.parse(parameterValue),
        });
    }
}
exports.AtomicPredicateString = AtomicPredicateString;
//# sourceMappingURL=AtomicPredicateString.js.map